import type { TrainingLessonSpecific } from './trainingLessonUi';

export const highPriest2ShepherdingEn: TrainingLessonSpecific = {
  intro:
    'A high priest cares for souls, not numbers. Many ward crises are not doctrinal—they are relational (pride, misunderstanding, fatigue). A good spiritual leader does not “win arguments”; he earns trust.',
  objectives: [
    'Learn the “pastoral” focus of the priesthood: care for souls, not numbers.',
    'Strengthen unity and peace in the local church (avoid gossip and contention).',
    'Understand how to counsel with meekness and clarity.',
    'Develop discernment and prudence (what to say, when, and to whom).',
    'Create a simple but real 30-day spiritual service plan.',
  ],
  briefHeading: 'Shepherding in brief',
  briefBody:
    'Listen before speaking, pray for discernment, and seek peace without avoiding truth. Caring for the flock is daily work of charity.',
  scriptures: [
    { ref: 'John 21:15–17', text: 'Feed my sheep.' },
    { ref: 'Mosiah 18:8–10', text: '…mourn with those that mourn; yea, and comfort those that stand in need of comfort…' },
    { ref: 'D&C 121:43–44', text: '…reproving betimes with sharpness… showing forth afterwards an increase of love…' },
    { ref: 'Ephesians 4:29', text: '…let no corrupt communication proceed out of your mouth, but that which is good…' },
    { ref: 'Alma 7:11–12', text: '…he will take upon him the pains and the sicknesses of his people… that he may know how to succor his people…' },
  ],
  didYouKnow: [
    'Many ward crises are not doctrinal—they are relational (pride, misunderstanding, fatigue).',
    'A good spiritual leader does not “win arguments”; he earns trust.',
  ],
  practiceItems: [
    'Identify one source of contention you can cut (gossip, sarcasm, criticism)',
    'Practice a peace phrase: “Let’s speak to build, not to divide.”',
    'Visit or call one person who is weakening (respectfully, without pressure)',
    'Prepare one simple counsel (one idea + one scripture + one invitation)',
    'Do an “invisible” service (no one has to know)',
    '30-day plan: pick one caring habit (weekly contact, daily prayer for someone, etc.)',
  ],
  reflectionQuestions: [
    'What makes me react with pride when I counsel?',
    'How can I be more prudent with my words?',
    'Whom should I care for without judging?',
  ],
  actionText:
    'Unity first: for seven days, drop one habit that stirs contention and replace it with one that edifies.',
};
